import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { authApiActions } from '../actions/authentication.actions';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PushService } from 'src/app/core/services/push.service';

@Injectable()
export class AuthenticationEffects {
  constructor(private actions$: Actions, private authenticationService: AuthenticationService, private router: Router, private pushService: PushService, private dialog: MatDialog) { }

  // Las notificaciones vienen activas por defecto: al ingresar se pide el permiso (el clic en
  // Ingresar cuenta como gesto del usuario) y se registra el navegador. El toggle del panel
  // sirve para desactivarlas; si el afiliado las desactivó, register() lo respeta.
  pushRegister$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(authApiActions.loginSuccess),
      tap(({ user }) => this.pushService.register(user?.access_token?.token, true))
    );
  }, { dispatch: false });

  login$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(authApiActions.loginRequest.type),
      switchMap((action: Action & { docType: number; docNumber: number; password: string }) =>
        this.authenticationService.login({ docType: action.docType, password: action.password, docNumber: action.docNumber }).pipe(
          map(payload => authApiActions.loginSuccess({ user: payload })),
          catchError(error => {
            const response = error.error;
            return of(authApiActions.loginFailure({ error: response }));
          })
        )
      )
    );
  });
  logout$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(authApiActions.logout.type),
      map(() => {
        // Los modales no se cierran solos al navegar con el router: sin esto quedan encima del login
        this.dialog.closeAll();
        this.router.navigateByUrl('');
        return authApiActions.logoutSuccess();
      }
      ))
  }
  );
}


